@if (menuItems.length) {
  <nav class="bn-submenu">
    <ul>
      @for (menuItem of menuItems; track menuItem.id ?? $index) {
        <ng-container *featureFlag="menuItem.featureFlag">
          <li
            *roleIds="menuItem.roleIds"
            class="bn-submenu__item"
            routerLinkActive="bn-submenu__item--is-active"
            [ngClass]="{ 'bn-submenu__item--has-children': menuItem.children?.length }"
            [routerLinkActiveOptions]="{ exact: !!menuItem.exactRouterLinkActive }">
            @if (menuItem.route) {
              <a
                class="bn-submenu__link"
                [routerLink]="menuItem.route">
                @if (menuItem.icon) {
                  <fa-icon
                    class="bn-submenu__icon"
                    [icon]="menuItem.icon" />
                }
                <span>{{ menuItem.name }}</span>
                @if (menuItem.statusLight) {
                  <span class="ms-1 bn-submenu__status-light bn-submenu__status-light--{{ menuItem.statusLight }}"></span>
                }
                @if (menuItem.badge?.text) {
                  <bn-web-ui-badge
                    contentClass="ms-auto bn-submenu__badge me-2"
                    [color]="menuItem.badge?.context"
                    [size]="menuItem.badge?.size"
                    [tooltip]="menuItem.badge?.tooltip"
                    [type]="menuItem.badge?.type"
                    >{{ menuItem.badge?.text }}</bn-web-ui-badge
                  >
                }
                @if (menuItem.children?.length) {
                  <fa-icon
                    class="bn-submenu__icon-arrow"
                    icon="chevron-down" />
                }
              </a>
            }
            @if (menuItem.url) {
              <a
                class="bn-submenu__link bn-submenu__link--ext"
                [href]="menuItem.url"
                [target]="menuItem.target">
                @if (menuItem.icon) {
                  <fa-icon
                    class="bn-submenu__icon"
                    [icon]="menuItem.icon" />
                }
                <span>{{ menuItem.name }}</span>
                @if (menuItem.statusLight) {
                  <span class="ms-1 bn-submenu__status-light bn-submenu__status-light--{{ menuItem.statusLight }}"></span>
                }
                <fa-icon
                  class="bn-submenu__icon-ext"
                  icon="arrow-up-right-from-square" />
              </a>
            }
            @if (menuItem.children?.length) {
              <ul class="bn-submenu__submenu">
                @for (childItem of menuItem.children; track childItem.id ?? $index) {
                  <li class="bn-submenu__submenu__item">
                    @if (childItem.route) {
                      <a
                        class="bn-submenu__submenu__link"
                        routerLinkActive="bn-submenu__submenu__link--is-active"
                        [routerLink]="childItem.route"
                        [routerLinkActiveOptions]="{ exact: !!childItem.exactRouterLinkActive }">
                        <span>{{ childItem.name }}</span>
                        @if (childItem.statusLight) {
                          <span class="ms-1 bn-submenu__status-light bn-submenu__status-light--{{ childItem.statusLight }}"></span>
                        }
                        @if (childItem.badge?.text) {
                          <bn-web-ui-badge
                            contentClass="ms-auto bn-submenu__badge"
                            [color]="childItem.badge?.context"
                            [size]="childItem.badge?.size"
                            [tooltip]="childItem.badge?.tooltip"
                            [type]="childItem.badge?.type"
                            >{{ childItem.badge?.text }}</bn-web-ui-badge
                          >
                        }
                      </a>
                    }
                    @if (childItem.url) {
                      <a
                        class="bn-submenu__submenu__link"
                        [href]="childItem.url"
                        [target]="childItem.target">
                        <span>{{ childItem.name }}</span>
                        @if (childItem.statusLight) {
                          <span class="ms-1 bn-submenu__status-light bn-submenu__status-light--{{ childItem.statusLight }}"></span>
                        }
                      </a>
                    }
                  </li>
                }
              </ul>
            }
          </li>
        </ng-container>
      }
    </ul>
    @if (isLoading) {
      <bn-web-ui-loading
        background="dark"
        size="sm" />
    }
  </nav>
}
